import { Grid } from '@mui/material';
import EstablishmentFormDetails from '../EstablishmentFormDetails';
import EstablishmentFormAddress from '../EstablishmentFormAddress';
import EstablishmentFormVideo from '../EstablishmentFormVideo';
import useEstablishmentMutation from '@establishment/hooks/useEstablishmentMutation';
import { useEffect } from 'react';

const EstablishmentDetails = () => {
  const { setMode } = useEstablishmentMutation();
  useEffect(() => {
    setMode('edit');
  }, []);

  return (
    <Grid container gap={3}>
      <Grid item xs={3.8}>
        <EstablishmentFormDetails />
      </Grid>
      <Grid item xs={3.8}>
        <EstablishmentFormAddress />
      </Grid>
      <Grid item xs={3.8}>
        <EstablishmentFormVideo />
      </Grid>
    </Grid>
  );
};

export default EstablishmentDetails;
